module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNTEyIiB3aWR0aD0iNTEyIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiI+CiAgPGcgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2Utd2lkdGg9IjFwdCI+CiAgICA8cGF0aCBmaWxsPSIjZDUyYjFlIiBkPSJNMCAwaDUxMS45ODR2NTExLjk4M0gweiIvPgogICAgPGcgZmlsbD0iI2ZmZiI+CiAgICAgIDxwYXRoIGQ9Ik05NS45OTQgMjA3Ljk5M2gzMTkuOTl2OTUuOTk0SDk1Ljk5M3oiLz4KICAgICAgPHBhdGggZD0iTTIwNy45OSA5NS45OTVoOTUuOTk1djMxOS45OUgyMDcuOTl6Ii8+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/1x1/ch.svg
// module id = ./node_modules/flag-icon-css/flags/1x1/ch.svg
// module chunks = 0